import { Component, Input, ElementRef, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { SelectComponent } from 'ng2-select/ng2-select';

//declare var module: any;

@Component({
    selector: 'ng-select-ext', 
    styleUrls: ['ng2-select-ext.component.css'],
    templateUrl: 'ng2-select-ext.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => Ng2SelectExtComponent),
            multi: true
        }
    ]
})
export class Ng2SelectExtComponent extends SelectComponent {
    @Input() comboInputId: string;
    @Input() simpleInputId: string;

    constructor(element: ElementRef, sanitizer: DomSanitizer) {
        super(element, sanitizer);
    }
}
